import { FunctionComponent, useEffect, useMemo, useRef, useState } from "react";

import { useAuthorizationContext } from "@digital-services/shell";

import {
  createPropsForRoutes,
  initSingleSpaApps
} from "./bootstrapMicroFrontends";

export const MicroFrontends: FunctionComponent = () => {
  const [mainContentEl, setMainContentEl] = useState<HTMLElement | undefined>(
    undefined
  );

  const { userData, getAccessToken } = useAuthorizationContext();

  const initializedRef = useRef(false);
  // StrictMode double `useEffect()` execution, causing double registration/unregistration of Single-SPA apps.
  // Initial idea was to using `let` outside React lifecycle but it's NOT safe under StrictMode.
  // And `React.useRef()` survives re-renders and avoids double init.

  useEffect(() => {
    const el = document.getElementById("main-content") ?? undefined;
    setMainContentEl(el);
  }, []);

  const ready = useMemo(() => {
    if (!mainContentEl) return false;
    if (!userData) return false;

    return true;
  }, [mainContentEl, userData]);

  useEffect(() => {
    if (!ready) return;
    if (initializedRef.current) return;

    initializedRef.current = true;

    // Note that here, it's a first place where User Roles fetched from API and injected further to traverse to mife.Common and mife.FOTA

    const roles = userData?.roles ?? [];
    const customProps = createPropsForRoutes(getAccessToken, userData!, roles);
    const cleanup = initSingleSpaApps(mainContentEl!, customProps);

    return () => {
      cleanup();
      initializedRef.current = false;
    };
  }, [ready]);
  // It's IMPORTANT to not enter below useEffect more than twice
  // That is why we need to stick to ONLY one dependency `ready`.
  // Otherwise, React useEffect() enters more times and then `single-spa` tries to register application again which throws an Error.

  return null;
};
